import {
  listarClientesDocumentales,
  listarProveedoresDocumentales,
  listarProveedoresTerrestres
} from "@/constants/serviciosLogisticos";
import { listarLiquidacionesPreliminares, agregarActualizarLiquidacionesPreliminares } from "../constants/serviciosLogisticos";

export default {
  namespaced: true,

  state: {

    // Data para dataTables
    dataTableProvTerrestres: [],
    dataTableProvTerrestresFiltrada: [],
    dataSeleccionadaProvTerrestres: [],

    // Data para select
    dataListaProveedores: [],
    dataListaPuertos: [],
    dataListaTiposCarga: [],
    dataProviderExtraCost: [],
    showLoadingProviderExtraCost: false,
    listCarriers: [],
    listCurrencies: [],
    extraCostTypes: [],
    unityPayments: [],
    containerTypes: [],

    showModalUpdateProviderExtraCost: false,
    showModalDuplicateProviderExtraCost: false,
    showLoadingUpdateProviderExtraCost: false,
    showModalUpdateManyProviderExtraCost: false,
    showBtnExportProviderExtraCost: false,
    showModalFilterProviderExtraCost: false,

    allExtraCostTypes: [],
    allCarriers: [],

    //**************************************************************** //
    //*************** proveedores documentales *********************** //
    //**************************************************************** //
    dataDocumentariesProviders: [],
    dataDataTableDocumentariesProviders: [],
    providersList: [],
    containersTypeList: [],
    servicesTypeList: [],
    currenciesTypeList: [],
    extraCostsTypeList: [],
    clientsList: [],
    documentariesTariffsSelected: [],
    documentariesTariffsSelectedIds: [],
    documentariesTariffsClearSelection: false,
    documentariesTariffsShowEditModal: false,
    //**************************************************************** //
    //****************** clientes documentales *********************** //
    //**************************************************************** //
    dataDocumentariesClients: [],
    dataDataTableDocumentariesClients: [],
    documentariesProvidersTariffsSelected: [],
    documentariesProvidersTariffsSelectedIds: [],
    customersList: [],

    //**************************************************************** //
    //*************** proveedores terrestres *********************** //
    //**************************************************************** //
    groundPlantsList : [],
    dataGroundProviders: [],
    dataDataTableGroundProviders: [],
    groundTariffsSelected: [],
    groundTariffsSelectedIds: [],
    groundTariffsClearSelection: false,
    groundTariffsShowEditModal: false,
    groundTariffsPolsList: [],
    groundTariffsPlantsList: [],
    groundTariffsPodsList: [],
    groundTariffsZonesList: [],
    groundTariffsServicesList: [],
    groundTariffsExtraCostType: [],

    //******************* clientes extra cost ************************************** //
    dataTableClienteExtraCosto: [] ,
    showLoadingClienteExtraCosto: false ,
    showLoadingClienteExtraCostoForm: false ,
    showModalAgregarClienteExtraCostoModal: false ,
    showModalEditClienteExtraCostoModal: false ,
    showModalEditMultipleClienteExtraCostoModal: false ,
    showModalFilterClienteExtraCostoModal: false ,
    showBtnExporterClienteExtraCostoModal: false ,

    //******************* Clientes Terrestres ************************************** //
    dataTableClientGround: [],
    showLoadingClientGround: false ,
    portsList: [],
    zonesList: [],
    integralServiceType : [],
    showLoadingClienteGroundForm: false ,
    showModalEditClientGroundModal: false ,
    showModalEditSimpleClientGroundModal: false ,
    showModalFiltersClientGroundModal: false ,
    showBtnExportFiltersClientGroundModal: false ,

    //******************* Liquidaciones de extra costos ************************************** //
    dataTableLiqPreliminaresClientes: [],
    dataTableLiqPreliminaresProveedores: [],
    vesselsList : [],
    loadingLiqClientes : false,
    loadingLiqProveedores : false,
    respAgregarActualizarLiquidacionesPreliminares: {},
    respAgregarActualizarLiquidacionesPreliminaresProveedor: {},
    abrirModalEditar: false,
    abrirModalEditarProveedor: false,
    isEditarModal : false,
    ivaList : [],
    blList : [],
    

  },

  mutations: {

    setDataProviderExtraCost(state, payload) {
      state.dataProviderExtraCost = payload;
    },

    setShowLoadingProviderExtraCost(state, payload) {
      state.showLoadingProviderExtraCost = payload;
    },

    setListCarriers(state, payload) {
      state.listCarriers = payload;
    },

    setListCurrencies(state, payload) {
      state.listCurrencies = payload;
    },

    setExtraCostTypes(state, payload) {
      state.extraCostTypes = payload;
    },

    setUnityPayments(state, payload) {
      state.unityPayments = payload;
    },

    setShowModalUpdateProviderExtraCost(state, payload) {
      state.showModalUpdateProviderExtraCost = payload;
    },

    setShowLoadingUpdateProviderExtraCost(state, payload) {
      state.showLoadingUpdateProviderExtraCost = payload;
    },

    setContainerTypes(state, payload) {
      state.containerTypes = payload;
    },

    setShowModalDuplicateProviderExtraCost(state, payload) {
      state.showModalDuplicateProviderExtraCost = payload;
    },

    setShowModalUpdateManyProviderExtraCost(state, payload) {
      state.showModalUpdateManyProviderExtraCost = payload;
    },

    setShowBtnExportProviderExtraCost(state, payload) {
      state.showBtnExportProviderExtraCost = payload;
    },

    setShowModalFilterProviderExtraCost(state, payload) {
      state.showModalFilterProviderExtraCost = payload;
    },

    //**************************************************************** //
    //*************** proveedores documentales *********************** //
    //**************************************************************** //

    async setDataDocumentariesProviders(state) {
      state.dataDocumentariesProviders = await listarProveedoresDocumentales();
    },

    setDataDataTableDocumentariesProviders(state, payload) {
      state.dataDataTableDocumentariesProviders = payload;
    },

    setDocumentariesProvidersList(state, payload) {
      state.providersList = payload;
    },

    setDocumentariesProvidersContainersTypeList(state, payload) {
      state.containersTypeList = payload;
    },

    setDocumentariesServicesTypeList(state, payload) {
      state.servicesTypeList = payload;
    },

    setDocumentariesCurrenciesTypeList(state, payload) {
      state.currenciesTypeList = payload;
    },

    setDocumentariesExtraCostsList(state, payload) {
      state.extraCostsTypeList = payload;
    },

    setDocumentariesTariffsSelected(state, payload) {
      state.documentariesTariffsSelected = payload;
    },

    setDocumentariesTariffsSelectedIds(state, payload) {
      state.documentariesTariffsSelectedIds = payload;
    },

    setDocumentariesTariffsClearSelection(state, payload) {
      state.documentariesTariffsClearSelection = payload;
    },

    setDocumentariesTariffsShowEditModal(state, payload) {
      state.documentariesTariffsShowEditModal = payload;
    },

    //**************************************************************** //
    //*************** clientes documentales *********************** //
    //**************************************************************** //

    async setDataDocumentariesClients(state) {
      state.dataDocumentariesClients = await listarClientesDocumentales();
    },

    setDataDataTableDocumentariesClients(state, payload) {
      state.dataDataTableDocumentariesClients = payload;
    },

    setDocumentariesCustomersList(state, payload) {
      state.customersList = payload;
    },

    setDocumentariesProvidersTariffsSelected(state, payload) {
      state.documentariesProvidersTariffsSelected = payload;
    },

    setDocumentariesProvidersTariffsSelectedIds(state, payload) {
      state.documentariesProvidersTariffsSelectedIds = payload;
    },

    //**************************************************************** //
    //*************** clientes extra costos  ************************* //
    //**************************************************************** //

    setShowModalAgregarClienteExtraCostoModal(state, payload) {
      state.showModalAgregarClienteExtraCostoModal = payload;
    },

    setDataTableClienteExtraCosto(state, payload) {
      state.dataTableClienteExtraCosto = payload;
    },

    setClientsList(state, payload) {
      state.clientsList = payload;
    },

    setShowLoadingClienteExtraCosto(state, payload) {
      state.showLoadingClienteExtraCosto = payload;
    },

    setShowModalEditClienteExtraCostoModal(state, payload) {
      state.showModalEditClienteExtraCostoModal = payload;
    },

    setShowLoadingClienteExtraCostoForm(state, payload) {
      state.showLoadingClienteExtraCostoForm = payload;
    },

    setShowModalEditMultipleClienteExtraCostoModal(state, payload) {
      state.showModalEditMultipleClienteExtraCostoModal = payload;
    },

    setShowModalFilterClienteExtraCostoModal(state, payload) {
      state.showModalFilterClienteExtraCostoModal = payload;
    },

    setShowBtnExporterClienteExtraCostoModal(state, payload) {
      state.showBtnExporterClienteExtraCostoModal = payload;
    },

    setAllExtraCostTypes(state, payload) {
      state.allExtraCostTypes = payload;
    },

    setAllCarriers(state, payload) {
      state.allCarriers = payload;
    },

    //**************************************************************** //
    //*************** proveedores terrestres ************************* //
    //**************************************************************** //

    async setDataGroundProviders(state) {
      state.dataGroundProviders = await listarProveedoresTerrestres();
    },

    setDataDataTableGroundProviders(state, payload) {
      state.dataDataTableGroundProviders = payload;
    },

    setGroundProvidersList(state, payload) {
      state.providersList = payload;
    },

    setGroundProvidersContainersTypeList(state, payload) {
      state.containersTypeList = payload;
    },

    setGroundServicesTypeList(state, payload) {
      state.servicesTypeList = payload;
    },

    setGroundCurrenciesTypeList(state, payload) {
      state.currenciesTypeList = payload;
    },

    setGroundExtraCostsList(state, payload) {
      state.extraCostsTypeList = payload;
    },

    setGroundTariffsSelected(state, payload) {
      state.groundTariffsSelected = payload;
    },

    setGroundTariffsSelectedIds(state, payload) {
      state.groundTariffsSelectedIds = payload;
    },

    setGroundTariffsClearSelection(state, payload) {
      state.groundTariffsClearSelection = payload;
    },

    setGroundTariffsShowEditModal(state, payload) {
      state.groundTariffsShowEditModal = payload;
    },

    setGroundTariffsPolsList(state, payload) {
      state.groundTariffsPolsList = payload;
    },

    setGroundTariffsPlantsList(state, payload) {
      state.groundTariffsPlantsList = payload;
    },
    setDataTableClientGround(state, payload) {
      state.dataTableClientGround = payload;
    },
    setShowLoadingClientGround(state, payload) {
      state.showLoadingClientGround = payload;
    },
    setPortsList(state, payload) {
      state.portsList = payload;
    },
    setZonesList(state, payload) {
      state.zonesList = payload;
    },
    setIntegralServiceType(state, payload) {
      state.integralServiceType = payload;
    },
    setShowLoadingClienteGroundForm(state, payload) {
      state.showLoadingClienteGroundForm = payload;
    },
    setShowModalEditClientGroundModal(state, payload) {
      state.showModalEditClientGroundModal = payload;
    },

    setShowModalEditSimpleClientGroundModal(state, payload) {
      state.showModalEditSimpleClientGroundModal = payload;
    },

    setShowModalFiltersClientGroundModal(state, payload) {
      state.showModalFiltersClientGroundModal = payload;
    },
    setShowBtnExportFiltersClientGroundModal(state, payload) {
      state.showBtnExportFiltersClientGroundModal = payload;
    },

    setGroundTariffsPodsList(state, payload) {
      state.groundTariffsPodsList = payload;
    },

    setGroundTariffsZonesList(state, payload) {
      state.groundTariffsZonesList = payload;
    },

    setGroundTariffsServicesList(state, payload) {
      state.groundTariffsServicesList = payload;
    },

    setGroundTariffsExtraCostType(state, payload) {
      state.groundTariffsExtraCostType = payload;
    },

    setGroundPlantsList(state, payload) {
      state.groundPlantsList = payload;
    },

    async setDataTableLiqPreliminares(state, payload) {

      const { type } = payload; // 1: Clientes - 2: Proveedores

      if (payload.filters) {
        
        let { data } = await listarLiquidacionesPreliminares(payload);

        if (type == 1) {
          state.dataTableLiqPreliminaresClientes = data;
        } else {
          state.dataTableLiqPreliminaresProveedores = data;
        }

      } else {

        let { data, customers_list, vessels_list, currency_list, carriers_list, has_iva_list, is_bl_list } = await listarLiquidacionesPreliminares(payload);

        if (type == 1) {
          state.dataTableLiqPreliminaresClientes = data;
        } else {
          state.dataTableLiqPreliminaresProveedores = data;
        }
        
        state.vesselsList        = vessels_list;
        state.customersList      = customers_list;
        state.listCarriers       = carriers_list;
        state.currenciesTypeList = currency_list;
        state.ivaList            = has_iva_list;
        state.blList             = is_bl_list;
        
      }

      

    },

    async setAgregarActualizarLiquidacionesPreliminares(state, payload){

      const data = await agregarActualizarLiquidacionesPreliminares(payload);

      console.log(data);
      

      if (payload.type == 1) {
        state.respAgregarActualizarLiquidacionesPreliminares = data;
      } else if (payload.type == 2) {

        state.respAgregarActualizarLiquidacionesPreliminaresProveedor = [];
        state.respAgregarActualizarLiquidacionesPreliminaresProveedor = data;

      }
    },

    setAbrirModalEditar(state, payload){
      state.abrirModalEditar = payload;
    },
    setAbrirModalEditarProveedor(state, payload){
      state.abrirModalEditarProveedor = payload;
    },

    setIsEditarModal(state, payload){
      state.isEditarModal = payload;
    },

    setExtraCostsTypeList(state, payload){
      state.extraCostsTypeList = payload;
    }

  },

  actions: {

    actionSetDataProviderExtraCost({ commit }, data) {
      commit("setDataProviderExtraCost", data);
    },

    actionSetShowLoadingProviderExtraCost({ commit }, data) {
      commit("setShowLoadingProviderExtraCost", data);
    },

    actionSetListCarriers({ commit }, data) {
      commit("setListCarriers", data);
    },

    actionSetListCurrencies({ commit }, data) {
      commit("setListCurrencies", data);
    },

    actionSetExtraCostTypes({ commit }, data) {
      commit("setExtraCostTypes", data);
    },

    actionSetUnityPayments({ commit }, data) {
      commit("setUnityPayments", data);
    },

    actionSetShowModalUpdateProviderExtraCost({ commit }, data) {
      commit("setShowModalUpdateProviderExtraCost", data);
    },
    actionSetShowLoadingUpdateProviderExtraCost({ commit }, data) {
      commit("setShowLoadingUpdateProviderExtraCost", data);
    },

    actionSetContainerTypes({ commit }, data) {
      commit("setContainerTypes", data);
    },

    actionSetShowModalDuplicateProviderExtraCost({ commit }, data) {
      commit("setShowModalDuplicateProviderExtraCost", data);
    },

    actionsSetShowModalUpdateManyProviderExtraCost({ commit }, data) {
      commit("setShowModalUpdateManyProviderExtraCost", data);
    },

    actionsSetShowBtnExportProviderExtraCost({ commit }, data) {
      commit("setShowBtnExportProviderExtraCost", data);
    },

    actionSetShowModalFilterProviderExtraCost({ commit }, data) {
      commit("setShowModalFilterProviderExtraCost", data);
    },

    //**************************************************************** //
    //*************** proveedores documentales *********************** //
    //**************************************************************** //

    actionSetDataDocumentariesProviders({ commit }, data) {
      commit("setDataDocumentariesProviders", data);
    },

    actionSetDataDataTableDocumentariesProviders({ commit }, data) {
      commit("setDataDataTableDocumentariesProviders", data);
    },

    actionSetDocumentariesProvidersList({ commit }, data) {
      commit("setDocumentariesProvidersList", data);
    },

    actionSetDocumentariesContainersTypeList({ commit }, data) {
      commit("setDocumentariesProvidersContainersTypeList", data);
    },

    actionSetDocumentariesServicesTypeList({ commit }, data) {
      commit("setDocumentariesServicesTypeList", data);
    },

    actionSetDocumentariesCurrenciesTypeList({ commit }, data) {
      commit("setDocumentariesCurrenciesTypeList", data);
    },

    actionSetDocumentariesExtraCostsList({ commit }, data) {
      commit("setDocumentariesExtraCostsList", data);
    },

    actionSetDocumentariesTariffsSelected({ commit }, data) {
      commit("setDocumentariesTariffsSelected", data);
    },

    actionSetDocumentariesTariffsSelectedIds({ commit }, data) {
      commit("setDocumentariesTariffsSelectedIds", data);
    },

    actionSetDocumentariesTariffsClearSelection({ commit }, data) {
      commit("setDocumentariesTariffsClearSelection", data);
    },

    actionSetDocumentariesTariffsShowEditModal({ commit }, data) {
      commit("setDocumentariesTariffsShowEditModal", data);
    },

    //**************************************************************** //
    //****************** clientes documentales *********************** //
    //**************************************************************** //

    actionSetDataDocumentariesClients({ commit }, data) {
      commit("setDataDocumentariesClients", data);
    },

    actionSetDataDataTableDocumentariesClients({ commit }, data) {
      commit("setDataDataTableDocumentariesClients", data);
    },

    actionSetDocumentariesCustomersList({ commit }, data) {
      commit("setDocumentariesCustomersList", data);
    },

    actionSetDocumentariesProvidersTariffsSelected({ commit }, data) {
      commit("setDocumentariesProvidersTariffsSelected", data);
    },

    actionSetDocumentariesProvidersTariffsSelectedIds({ commit }, data) {
      commit("setDocumentariesProvidersTariffsSelectedIds", data);
    },

    //**************************************************************** //
    //*************** clientes extra costos  ************************* //
    //**************************************************************** //

    actionSetShowModalAgregarClienteExtraCostoModal({ commit }, data) {
      commit("setShowModalAgregarClienteExtraCostoModal", data);
    },

    actionSetDataTableClienteExtraCosto({ commit }, data) {
      commit("setDataTableClienteExtraCosto", data);
    },

    actionSetClientsList({ commit }, data) {
      commit("setClientsList", data);
    },

    actionSetShowLoadingClienteExtraCosto({ commit }, data) {
      commit("setShowLoadingClienteExtraCosto", data);
    },

    actionSetShowModalEditClienteExtraCostoModal({ commit }, data) {
      commit("setShowModalEditClienteExtraCostoModal", data);
    },

    actionSetShowLoadingClienteExtraCostoForm({ commit }, data) {
      commit("setShowLoadingClienteExtraCostoForm", data);
    },

    actionSetShowModalEditMultipleClienteExtraCostoModal({ commit }, data) {
      commit("setShowModalEditMultipleClienteExtraCostoModal", data);
    },

    actionSetShowModalFilterClienteExtraCostoModal({ commit }, data) {
      commit("setShowModalFilterClienteExtraCostoModal", data);
    },
    actionSetShowBtnExporterClienteExtraCostoModal({ commit }, data) {
      commit("setShowBtnExporterClienteExtraCostoModal", data);
    },


    //**************************************************************** //
    //*************** proveedores terrestres *********************** //
    //**************************************************************** //

    actionSetDataGroundProviders({ commit }, data) {
      commit("setDataGroundProviders", data);
    },

    actionSetDataDataTableGroundProviders({ commit }, data) {
      commit("setDataDataTableGroundProviders", data);
    },

    actionSetGroundProvidersList({ commit }, data) {
      commit("setGroundProvidersList", data);
    },

    actionSetGroundContainersTypeList({ commit }, data) {
      commit("setGroundProvidersContainersTypeList", data);
    },

    actionSetGroundServicesTypeList({ commit }, data) {
      commit("setGroundServicesTypeList", data);
    },

    actionSetGroundCurrenciesTypeList({ commit }, data) {
      commit("setGroundCurrenciesTypeList", data);
    },

    actionSetGroundExtraCostsList({ commit }, data) {
      commit("setGroundExtraCostsList", data);
    },

    actionSetGroundTariffsSelected({ commit }, data) {
      commit("setGroundTariffsSelected", data);
    },

    actionSetGroundTariffsPodsList({ commit }, data) {
      commit("setGroundTariffsPodsList", data);
    },

    actionSetGroundTariffsPlantsList({ commit }, data) {
      commit("setGroundTariffsPlantsList", data);
    },

    actionSetGroundTariffsPolsList({ commit }, data) {
      commit("setGroundTariffsPolsList", data);
    },

    actionSetGroundTariffsZonesList({ commit }, data) {
      commit("setGroundTariffsZonesList", data);
    },

    actionSetGroundTariffsServicesList({ commit }, data) {
      commit("setGroundTariffsServicesList", data);
    },
    actionSetGroundTariffsExtraCostType({ commit }, data) {
      commit("setGroundTariffsExtraCostType", data);
    },

    actionSetGroundTariffsSelectedIds({ commit }, data) {
      commit("setGroundTariffsSelectedIds", data);
    },

    actionSetGroundTariffsClearSelection({ commit }, data) {
      commit("setGroundTariffsClearSelection", data);
    },

    actionSetGroundTariffsShowEditModal({ commit }, data) {
      commit("setGroundTariffsShowEditModal", data);
    },

    actionSetAllExtraCostTypes({ commit }, data) {
      commit("setAllExtraCostTypes", data);
    },

    actionSetAllCarriers({ commit }, data) {
      commit("setAllCarriers", data);
    },
    actionSetDataTableClientGround({ commit }, data) {
      commit("setDataTableClientGround", data);
    },
    actionSetShowLoadingClientGround({ commit }, data) {
      commit("setShowLoadingClientGround", data);
    },
    actionSetPortsList({ commit }, data) {
      commit("setPortsList", data);
    },
    actionSetZonesList({ commit }, data) {
      commit("setZonesList", data);
    },
    actionSetIntegralServiceType({ commit }, data) {
      commit("setIntegralServiceType", data);
    },
    actionSetShowLoadingClienteGroundForm({ commit }, data) {
      commit("setShowLoadingClienteGroundForm", data);
    },
    actionSetShowModalEditClientGroundModal({ commit }, data) {
      commit("setShowModalEditClientGroundModal", data);
    },

    actionSetShowModalEditSimpleClientGroundModal({ commit }, data) {
      commit("setShowModalEditSimpleClientGroundModal", data);
    },

    actionSetShowModalFiltersClientGroundModal({ commit }, data) {
      commit("setShowModalFiltersClientGroundModal", data);
    },

    actionSetShowBtnExportFiltersClientGroundModal({ commit }, data) {
      commit("setShowBtnExportFiltersClientGroundModal", data);
    },

    actionSetGroundPlantsList({ commit }, data) {
      commit("setGroundPlantsList", data);
    },

    actionSetDataTableLiqPreliminares({ commit }, data) {
      commit("setDataTableLiqPreliminares", data);
    },

    actionSetAgregarActualizarLiquidacionesPreliminares({ commit }, data) {
      commit("setAgregarActualizarLiquidacionesPreliminares", data);
    },

    actionSetAbrirModalEditar({commit}, data){
      commit("setAbrirModalEditar", data);
    },

    actionSetAbrirModalEditarProveedor({commit}, data){
      commit("setAbrirModalEditarProveedor", data);
    },

    actionSetIsEditarModal({commit}, data){
      commit("setIsEditarModal", data);
    },

    actionSetExtraCostsTypeList({commit}, data){
      commit("setExtraCostsTypeList", data);
    },
    
  }

};